import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";
import Hero from "./components/Hero";
import DongdongIntro from "./components/DongdongIntro";
import FeatureWorld from "./components/FeatureWorld";
import HotArticles from "./components/HotArticles";
import { CharacterPreview, SettingPreview } from "./components/Previews";
import { FaqPreview, Cta } from "./components/FaqCta";

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "洞洞杂货铺世界观解析站",
  url: "https://comworld1.github.io/",
  logo: "https://comworld1.github.io/vite.svg",
  description:
    "专注洞洞杂货铺漫画的世界观、洞洞含义、杂货铺设定、故事背景与隐藏线索的解析内容站。",
};

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "洞洞杂货铺世界观解析站",
  url: "https://comworld1.github.io/",
  description:
    "洞洞杂货铺漫画设定与世界观完整解析：洞洞含义、杂货铺设定、故事背景、角色关系与隐藏线索。",
};

export default function Home() {
  return (
    <>
      <Seo
        title="洞洞杂货铺漫画 - 洞洞杂货铺设定与世界观完整解析｜洞洞杂货铺漫画是什么？洞洞含义详解"
        description="想了解洞洞杂货铺漫画的世界观和故事背景？点开这里，从洞洞含义到杂货铺设定，全面解析这部作品的独特世界观、角色关系与核心设定，帮你快速读懂漫画的隐藏线索。"
        keywords="洞洞杂货铺漫画,洞洞杂货铺设定,洞洞杂货铺世界观,洞洞杂货铺故事背景,洞洞杂货铺漫画是什么"
        canonicalPath="/"
        jsonLd={[organizationLd, websiteLd]}
      />
      <Navbar />
      <main>
        <Hero />
        <DongdongIntro />
        <FeatureWorld />
        <HotArticles />
        <CharacterPreview />
        <SettingPreview />
        <FaqPreview />
        <Cta />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}